import { PaymentWithDetails } from '../types/payment.ts';

export const receiptService = {
	printReceipt(payment: PaymentWithDetails) {
		const receiptWindow = window.open('', '_blank');
		if (!receiptWindow) return;

		const content = document.getElementById('receipt-content')?.innerHTML;

		receiptWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Rent Receipt</title>
          <style>
            ${getReceiptStyles()}
          </style>
        </head>
        <body>
          <div class="receipt-container print-mode">
            <div class="watermark">PAID</div>
           
            ${content}
            <div class="company-info">
              This is a computer generated receipt and does not require a signature.
            </div>
          </div>
        </body>
      </html>
    `);

		receiptWindow.document.close();
		setTimeout(() => {
			receiptWindow.print();
			receiptWindow.close();
		}, 250);
	},
};

function getReceiptStyles() {
	return `
    @page {
      margin: 0;
      size: A4;
    }
    
    body {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      margin: 0;
      padding: 30px;
    }
    
    .receipt-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 40px;
      border: 2px solid #00aeff;
      position: relative;
    }

    .receipt-header {
      text-align: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 2px solid #00aeff;
      position: relative;
    }

    .receipt-header h2 {
      margin: 0 0 15px 0;
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 2px;
    }

    .tenant-name {
      font-size: 18px;
      font-weight: 500;
      margin: 10px 0;
      letter-spacing: 1px;
    }

    .receipt-no {
      font-size: 14px;
      color: #00aeff;
      letter-spacing: 1px;
    }

    .receipt-date {
      text-align: right;
      margin-bottom: 30px;
      font-size: 14px;
    }

    .receipt-body {
      margin: 30px 0;
      line-height: 2;
    }

    .receipt-body p {
      margin: 15px 0;
      font-size: 16px;
    }

    .receipt-body strong {
      font-weight: 600;
    }

    .receipt-footer {
      margin-top: 60px;
      margin-bottom: 80px;  /* Add margin to create space for company info */
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    .receipt-signature {
      text-align: center;
      min-width: 200px;
    }

    .signature-line {
      border-top: 1px solid #00aeff;
      margin-bottom: 5px;
    }

    .signature-text {
      font-size: 14px;
    }

    .company-info {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 12px;
      color: #00aeff;
      padding-top: 20px;
      border-top: 1px dashed #ccc;
      margin: 0 40px;
    }

    .watermark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      font-size: 100px;
      opacity: 0.05;
      pointer-events: none;
      z-index: 1;
    }

    @media print {
      @page {
        margin: 0;
        size: A4;
      }
      
      body {
        padding: 20px;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .receipt-container {
        border: none;
        padding: 20px;
      }

      .receipt-actions {
        display: none !important;
      }

      .watermark {
        opacity: 0.03;
      }

      .company-info {
        position: fixed;
        bottom: 30px;
        border-top: 1px dashed #00aeff;
      }
    }
  `;
}
